module.exports = __webpack_public_path__ + "static/images/blocked.0c014bc4929e108f0db35b6c0857527e.svg";